import DataGridRotateEffects from '../Cooperative/DataGridRotateEffects';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { sendEvent } from 'utils/Event';
import { toast } from 'react-toastify';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';
import { useTranslation } from 'react-i18next';

const RotateEffectsDataGridExploitation = ({ exploitation, setExploitation, from, cultures }) => {
  const { t } = useTranslation();
  const [exploit, setExploit] = useState(exploitation);
  const navigate = useNavigate();
  const exploitId = exploit?.id ?? +localStorage.getItem('exploitation');

  const { isOrganic } = useToggleSwitch(from, 'rotateEffects', () => {}, exploitId, null, null);

  useEffect(() => {
    loadData();
    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  const loadData = () => {
    if (localStorage.getItem('exploitation')) {
      setExploitation(isOrganic, exploitId, false, 'rotation')
        .then((resp) => setExploit(resp.data.data))
        .catch((err) => toast.error(err.data));
    } else {
      toast.info(t('message.selectExploitation'));
      navigate('/exploitation');
    }
  };

  return (
    <DataGridRotateEffects
      from={from}
      cultures={cultures?.data?.filter((culture) => culture.isCustomized === true)}
      refreshData={setExploitation}
      ownerId={exploitId}
    />
  );
};

export default RotateEffectsDataGridExploitation;
